// React imports
import React, { useEffect, useState } from 'react';

// Third-party imports
import { useAuth } from 'react-oidc-context';
import { useDispatch, useSelector } from 'react-redux';
import SearchableDropdown from 'src/components/SearchableDropdown';

// App imports
import { IReportee } from 'src/models/Reportee';
import { getResourceByManager } from 'src/redux/features/users/usersSlice';
import { fetchAllUserbyManager } from 'src/redux/features/users/usersSlice';
import en from 'src/messages/en.json';

export const SelectReportee = ({ data = [], onItemChange }) => {
  const [options, setOptions] = useState<IReportee[]>(data);
  const [dropDownLoading, setDropDownLoading] = useState(false);
  const filterByFields = ['name'];
  const auth = useAuth();
  const dispatch = useDispatch();

  const { data: managerReource, status: resourceLoading } =
    useSelector(getResourceByManager);

  useEffect(() => {
    const fetchReportees = async () => {
      setDropDownLoading(true);

      try {
        const response = await dispatch(
          fetchAllUserbyManager({
            email: auth?.user?.profile?.email,
          }),
        );
      } catch (error) {
        console.error('Error fetching reportees:', error);
      } finally {
        setDropDownLoading(false);
      }
    };

    if (auth?.user?.profile?.email) {
      fetchReportees();
    }
  }, [dispatch, auth?.user?.profile?.email]);
  useEffect(() => {
    setOptions(managerReource);
  }, [managerReource]);

  return (
    <SearchableDropdown
      labelKey="name"
      id="name"
      options={options.map((option, index) => ({
        label: option.name,
        value: option.email,
        isActive: option.isActive,
        key: `${option.email}-${index}`,
      }))}
      placeholder={en.Timesheet.Placeholder.selectReportee}
      onChange={onItemChange}
      showSearch={true}
      allowClear={true}
      optionRender={(option) => (
        <div key={option.data.value}>
          <div>
            {option.data.label}
            {option.data.isActive === false && (
              <span style={{ marginLeft: '0.125rem' }}>*</span>
            )}
          </div>
        </div>
      )}
      showArrow={true}
      loading={dropDownLoading}
    />
  );
};
